import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDatepickerNavigateEvent, NgbDateStruct, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { GuiService } from '../_services/gui-service/gui.service';
import { Papa, UnparseConfig } from 'ngx-papaparse';
import { PVInput, PVOutput } from '../_models/pv-data';
import { PvListProcessingService } from '../_services/pv-service/pv-list-processing.service';
import { saveAs } from 'file-saver';
import { GPlanService } from '../_services/gplan-service/gplan.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-pv-list-processing',
  templateUrl: './pv-list-processing.component.html',
  styleUrls: ['./pv-list-processing.component.css']
})
export class PvListProcessingComponent implements OnInit {
  selectedFile: File = null;
  selectedFileName: string = "";
  loadedPVList: Array<PVInput> = [];
  private areloadedPVList: boolean = false;
  inputPVList: Array<PVInput> = [];
  outputPVList: Array<PVOutput> = [];

  constructor(
    private pvService: PvListProcessingService,
    public activeModal: NgbActiveModal,
    private guiService: GuiService,
    private papa: Papa,
    private gPlanService: GPlanService,
  ) { }

  ngOnInit(): void {
    this.loadInputOutput();
  }

  /**
   * Load Input and Output PV lists if present
   */
  loadInputOutput() {
    let input: Array<PVInput> = [];
    let output: Array<PVOutput> = [];
    input = JSON.parse(localStorage.getItem('PvInput'));
    output = JSON.parse(localStorage.getItem('PvOutput'));
    this.loadedPVList = [];
    if (input && input.length > 0) {
      this.inputPVList = input;
    }
    if (output && output.length > 0) {
      this.outputPVList = output;
    }
  }

  /**
   * Retrive file from DOM and extract file name
   * @param event
   */
  onFileSelected(event: any): void {
    const fileInput = event.target;
    if (fileInput.files.length > 0) {
      this.selectedFile = event.target.files[0] as File;
      this.selectedFileName = fileInput.files[0].name;
    }
  }

  /**
   * Process csv file converting it in a PVInput[] array
   * @returns
   */
  processFile(): void {
    if (!this.selectedFile) {
      console.error('File not selected.');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const csvData = reader.result as string;

      // Parse CSV data to JSON using ngx-papaparse
      this.papa.parse(csvData, {
        complete: (result) => {
          console.log('Parsed CSV to JSON:', result.data);
          this.loadedPVList = result.data;
          this.areloadedPVList = true;
          this.inputPVList = [];
          this.outputPVList = [];
        },
        header: true,
      });
    };

    reader.readAsText(this.selectedFile);
  }

  isPvListProcessingisRunning(): boolean {
    return this.pvService.isPvListProcessingisRunning();
  }

  getUnsignedNumber(number: number) {
    let unsignedNumber = Math.abs(number);
    return unsignedNumber;
  }

  runPVListProcessing() {

    if (this.loadedPVList && this.loadedPVList.length > 0) {

      this.guiService.runPVListProcessing(this.loadedPVList).subscribe(() => {
        this.gPlanService.setGPlanRunning(true);
        this.areloadedPVList = false;
        localStorage.removeItem("PvInput");
        localStorage.removeItem("PvOutput")
        this.activeModal.dismiss('pvListProcessingStarted');
      });
    }
  }

  downloadOutput() {
    //unparse configuration
    const config: UnparseConfig = {
      //quotes: true,    // Add "" if needed
      header: true,    // add header
      delimiter: ';',  // add delimiter
      //newline: '\n',   //new row
    };

    //const headers to be used for ordering in the csv exported file
    const headers = [
      "requestTimestamp",
      "nodeToConnect",
      "kWp",
      "powerFactor",
      "status",
      "topologyId",
      "maxCableLoadPercent",
      "maxTrafoLoadPercent",
      "maxVoltageValue",
      "message"]

    //ordering by headers
    this.outputPVList = this.outputPVList.map(obj => {
      const sortedObj: any = {};
      headers.forEach(header => {
        sortedObj[header] = obj[header];
      });
      return sortedObj;
    });

    //generate csv from output json
    const csv = this.papa.unparse(this.outputPVList, config);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    //download file
    saveAs(blob, 'PV_output.csv');
  }



  sortObjectKeys(obj: any): any {
    return Object.keys(obj).sort().reduce((result, key) => {
      result[key] = obj[key];
      return result;
    }, {});
  }

  getPvListTemplate(){
    this.pvService.getPvListTemplate().pipe(
      catchError((error) => {
        console.error('An error occurred while: ' + error);
        return throwError(error);
      })).subscribe((response: ArrayBuffer) => {
        const blob = new Blob([response], {type: ' application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'PVListTemplate.csv';
        link.dispatchEvent( new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function() {
          window.URL.revokeObjectURL(link.href);
          link.remove();
        }, 100);
      })
  }

  getSelectedLanguage(): string{
    return localStorage.getItem('Language')
  }

}
